import { useMemo } from "react";
import { useLocalSearchParams, useRouter } from "expo-router";
import { closeCvShareRoute } from "../../../lib/cv-target-route";
import { CvShareSheet } from "../../../components/cv/CvShareSheet";
import type { CvVisibilityOptions } from "../../../components/cv/CVSharePanel";
import { downloadCvExport, type ExportFormat } from "../../../lib/cv-export";
import { useCVData } from "../../../lib/cv-mock-data";
import { getCvShareVisibilityDefaults } from "../../../lib/cv-privacy";
import { buildPublicCvRouteUrl } from "../../../lib/public-web";

export default function ShareScreen() {
  const router = useRouter();
  const { returnTo } = useLocalSearchParams<{ returnTo?: string }>();
  const close = () => closeCvShareRoute(router, returnTo);
  const { profile, target, privacy } = useCVData();
  const visibility = useMemo(
    () => getCvShareVisibilityDefaults(privacy),
    [privacy],
  );
  const publicUrl = useMemo(
    () => (profile.username ? buildPublicCvRouteUrl(profile.username) : null),
    [profile.username],
  );

  const onDownload = async (
    format: ExportFormat,
    options?: { visibility?: CvVisibilityOptions; variantId?: string | null },
  ) => {
    await downloadCvExport(format, {
      target,
      variantId: options?.variantId,
      visibility: options?.visibility ?? visibility,
    });
  };

  return (
    <CvShareSheet
      publicUrl={publicUrl}
      onDownload={onDownload}
      onClose={close}
    />
  );
}
